import React, { useState } from 'react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <> {/* Use a React Fragment to avoid adding extra DOM elements */}
      <nav className="navbar" data-scroll-sticky data-scroll>  {/* Navbar outside header, and made sticky */}
        <div className="logo-text">NRGPIX.CH</div>
        <img src="/nrgpix_logo_2025.png" alt="NRGPIX logo" className="navbar-logo" />
      </nav>
      <header className="hero" data-scroll-section>  {/* Hero section separate */}
        {/* Hero content will go here  */}
      </header>
    </>
  );
};

export default Navbar;